import apiEndpoints from './apiEndpoints';
import { getRequest } from './index';

export const getDropoffLocations = ({ addressUid }) =>
  getRequest(apiEndpoints.shippings.dropoffLocations, { addressUid });
